/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { TourVirtualArticlesResponse } from '../../models/tour-virtual-articles-response';

export interface GetConsigneeAddonsTourVirtualArticlesV3$Params {
  organizationSiteKey: KeyType;
  tourKey: KeyType;
}

export function getConsigneeAddonsTourVirtualArticlesV3(http: HttpClient, rootUrl: string, params: GetConsigneeAddonsTourVirtualArticlesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<TourVirtualArticlesResponse>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeAddonsTourVirtualArticlesV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('tourKey', params.tourKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TourVirtualArticlesResponse>;
    })
  );
}

getConsigneeAddonsTourVirtualArticlesV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/tours/{tourKey}/virtual-articles';
